import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import TextEncodeDecode from "../views/TextEncodeDecode.vue";
import ImageFormatConverter from "../views/ImageFormatConverter.vue";
import Error404 from "../views/Error404.vue";

Vue.use(VueRouter);

const routes = [
	// {
	// 	path: "/",
	// 	name: "Home",
	// 	component: Home,
	//  icon: "user-secret"
	// },
	{
		// path: "/text-encode-decode",
		path: "/",
		name: "Text Encode/Decode",
		component: TextEncodeDecode,
		icon: "exchange-alt"
	}
	// {
	// 	path: "/image-format-converter",
	// 	name: "Image Format Converter",
	// 	component: ImageFormatConverter,
	// 	icon: "images"
	// },
	// {
	// 	path: "*",
	// 	component: Error404,
	// 	icon: "images"
	// }
	// {
	// 	path: "/about",
	// 	name: "About",
	// 	// route level code-splitting
	// 	// this generates a separate chunk (about.[hash].js) for this route
	// 	// which is lazy-loaded when the route is visited.
	// 	component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
	// }
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes
});

export default router;
export {
	routes
}
